// languageData.js
export const languageData = {
  english: {
    address: "Address",
    city: "City",
    district: "District",
    state: "State",
    taluka: "Taluka",
    pincode: "Pincode",
    mobile: "Mobile No",
    contact: "Contact No",
  },
  hindi: {
    address: "पता",
    city: "शहर",
    district: "जिला",
    state: "राज्य",
    taluka: "तालुका",
    pincode: "पिनकोड",
    mobile: "मोबाइल नंबर",
    contact: "संपर्क नंबर",
  },
  gujarati: {
    address: "સરનામું",
    city: "શહેર",
    district: "જિલ્લો",
    state: "રાજ્ય",
    taluka: "તાલુકો",
    pincode: "પિનકોડ",
    mobile: "મોબાઈલ નંબર", 
    contact: "સંપર્ક નં",
  },
};
